var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72671 0C4.5118 0 5.16919 0.53 5.38484 1.25H10V2.25H5.38484C5.16919 2.97 4.5118 3.5 3.72671 3.5C2.94161 3.5 2.28422 2.97 2.06857 2.25H0V1.25H2.06857C2.28422 0.53 2.94161 0 3.72671 0ZM2.98137 1.75C2.98137 2.1635 3.31578 2.5 3.72671 2.5C4.13764 2.5 4.47205 2.1635 4.47205 1.75C4.47205 1.3365 4.13764 1 3.72671 1C3.31578 1 2.98137 1.3365 2.98137 1.75Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07478 7.25C1.29043 6.53 1.94783 6 2.73292 6C3.51801 6 4.1754 6.53 4.39106 7.25H9.93789V8.25H4.39106C4.1754 8.97 3.51801 9.5 2.73292 9.5C1.94783 9.5 1.29043 8.97 1.07478 8.25H0V7.25H1.07478ZM1.98758 7.75C1.98758 8.1635 2.32199 8.5 2.73292 8.5C3.14385 8.5 3.47826 8.1635 3.47826 7.75C3.47826 7.3365 3.14385 7 2.73292 7C2.32199 7 1.98758 7.3365 1.98758 7.75Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54683 4.25C5.76248 3.53 6.41988 3 7.20497 3C7.99006 3 8.64745 3.53 8.86311 4.25H9.93789V5.25H8.86311C8.64745 5.97 7.99006 6.5 7.20497 6.5C6.41988 6.5 5.76248 5.97 5.54683 5.25H0V4.25H5.54683ZM6.45963 4.75C6.45963 5.1635 6.79404 5.5 7.20497 5.5C7.6159 5.5 7.95031 5.1635 7.95031 4.75C7.95031 4.3365 7.6159 4 7.20497 4C6.79404 4 6.45963 4.3365 6.45963 4.75Z",
    fill: "#F7F7F7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.680ab9d27f5d48ed5ce358882910dd2b.svg";
export { ForwardRef as ReactComponent };